import { render } from "./TictactoeView.vue?vue&type=template&id=470e19d2&scoped=true"
import script from "./TictactoeView.vue?vue&type=script&lang=js"
export * from "./TictactoeView.vue?vue&type=script&lang=js"

import "./TictactoeView.vue?vue&type=style&index=0&id=470e19d2&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470e19d2"]])

export default __exports__